import {ADD_HEAD_ORGS, GET_HEAD_ORGS_BY_ID, GET_HEAD_ORGSS, UPDATE_HEAD_ORGS,} from "./HeadOrgsActions"

const initialState = {
  headOrgs: [],
  headOrg: null,
  tabValue: "1",
}

/**
 * reducer function to update state based on action
 * @param state: current state of the reducer
 * @param action: action to perform on the data
 * @constructor
 */
const OrganisationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_HEAD_ORGSS:
      return Object.assign({}, state, {
        headOrgs: action.headOrgs,
      })
    case ADD_HEAD_ORGS:
      return Object.assign({}, state, {
        headOrg: action.headOrg,
      })
    case GET_HEAD_ORGS_BY_ID:
      return Object.assign({}, state, {
        headOrg: action.headOrg,
      })
    case UPDATE_HEAD_ORGS:
      return Object.assign({}, state, {
        headOrg: action.headOrg,
      })

    default:
      return state
  }
}

export default OrganisationsReducer
